import { nanoid } from 'nanoid/async'
import { imageModal } from './imageModal'
import { updateNodeConnections } from '../../functions/utils'

// eslint-disable-next-line no-unused-vars
export default async (node, editor) => {
  const oldData = node.data
  const { value: imageData } = await imageModal(oldData, node)

  if (imageData && Object.values(imageData).length >= 1) {
    // Create text unique ID if there is not any
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }
        
    Object.assign(node.data, imageData)
    node.update()
    updateNodeConnections(node)
  }

  return false
}